<template>
    <div>
        <form-input v-model="data.company"
                    :rules="{min: 2, max: 100}"
                    :disabled="disabled"
                    name="billing.company"
                    :label="$t('label.billing_company_name')"/>

        <contact-form-inputs :data="data" :required="required" :street-required="required" slim disable-help name email :disabled="disabled" validation-prefix="billing." @locationchanged="data => $emit('changed', data)"/>
    </div>

</template>

<script>
import FormInputsMixin from "../FormInputsMixin";

    export default {
        name: 'BillingFormInputs',

        mixins: [FormInputsMixin],

        props: {
            required: {
                type: Boolean,
                default: false
            },
        }

    }
</script>
